import { HubApiMethods } from '../constants/HubApiMethods';
import { addLoginQueryParams } from '../utils/url';
import { appendUnityLoginIframe } from '../utils/landing';
import { HubJsonRpcRequest } from '../api/HubJsonRpcRequest';
import { GetUserTokenType } from '../domains/valueObject/SwitchUserProgressResponses';
import { Localization } from '../localization/localization';
import { ErrorSmallPopup } from '../popups/errorSmallPopup';
import { CustomJrpcErrResult } from '../general/modules/jsonRpc/jRpcErrResponse';
import { getUrlToLoginViaToken } from "./getUrlToLoginViaToken";

export async function guestWebAuth() {
    try {
        const hubResponse: CustomJrpcErrResult | GetUserTokenType = await HubJsonRpcRequest.makeRequest(
            HubApiMethods.WEB_GUEST_GET_TOKEN,
            {
                locale: window.app.config.locale,
                current_entry_point: window.app.config.current_entry_point,
                reg: false
            },
            window.app.deviceIdentifier
        );

        if ('error' in hubResponse) {
            throw new Error(hubResponse.error.message);
        }

        let url = getUrlToLoginViaToken(hubResponse.tether.token, hubResponse.tether.suid);
        url = addLoginQueryParams(url);
        appendUnityLoginIframe(url);
    } catch (exception) {
        window.Sentry.captureException(`Got exception on guest login ${JSON.stringify(exception)}`);

        const errorSmallPopup = ErrorSmallPopup.getInstance();
        errorSmallPopup.setMessage(Localization._n('feedback_common_error'));
        errorSmallPopup.setButtonText(Localization._n('ecommpay.button_to_retry'));
        errorSmallPopup.show();
        errorSmallPopup.setCallback(() => {
            errorSmallPopup.hide();
            location.reload();
        });
    }
}
